// extracted by mini-css-extract-plugin
export default {"switchContainer":"ManageUsers_switchContainer__2zZcy","addPadding":"ManageUsers_addPadding__fSf1T"};